import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlConstantsService } from '@pw-utils/services/url-constants/url-constants.service';
import { IForgotPasswordModalSettings } from '@shared/core/interfaces/forgot-password.interface';
import { Observable } from 'rxjs';

@Injectable()
export class ForgotPasswordService {
  constructor(private _http: HttpClient, private _urls: UrlConstantsService) {}

  public sendPasswordResetRequest(body: IForgotPasswordModalSettings): Observable<void> {
    return this._http.post<void>(this._urls.FORGOT_PASSWORD, body);
  }
}
